<template>
  <div class="home home-page">
    <header v-if="!isShowCamera" class="home-page__hero">
      <div class="home-page__hero-text">
        <h1 class="home-page__title">Бүртгэл</h1>
        <p class="home-page__subtitle">Track code уншуулж ачаа бүртгэнэ үү</p>
      </div>
    </header>

    <div class="home-page__panel">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm home-page__form"
      label-position="top" size="medium">
      <div v-if="isShowCamera" id="barcode-scanner" class="dce-video-container"></div>
      <div v-if="!isShowCamera">
        <el-row>
          <el-form-item>
            <el-col>
              <el-checkbox v-if="checked === false" v-model="checked" @change="getPackageList">Багц сонгох</el-checkbox>
              <el-select v-if="checked" placeholder="Багц сонгоно уу" class="w-90" v-model="ruleForm.code">
                <el-option v-for="item, index in packageList" :key="index" :value="item.code" :label="item.code">{{ item.code }}</el-option>
              </el-select>
              <el-alert v-if="errortext" :title="errortext" type="error" show-icon class="m-b-10 m-t-10" />
            </el-col>
          </el-form-item>
          <el-form-item label="TRACK CODE" prop="track_code">
            <span class="gray_text" v-if="checkPermissionsPage('erlian_branch')"> Таны бүртгэсэн бараа {{ returnCompanyName(this.selectCompany) }} хамаарна.</span>
            <el-col :span="21">
              <el-input class="w-90" ref="track_code" v-model="ruleForm.track_code" placeholder="TRACKCODE"
                @input="onBarcodeInput(ruleForm.track_code,'urt','track_code')" @blur="getTrackCodesBySamePhone('track_code')"
                clearable>
              </el-input>
            </el-col>
            <el-col :span="1">
              <el-button @click="startCamera('track_code')" type="warning" icon="el-icon-camera-solid" circle>
              </el-button>
            </el-col>
          </el-form-item>
        </el-row>
        <div v-if="this.successtext" class="home-page__status-banner">
          Трак код бүртгэсэн байна.<br>
          Төлөв: {{ returnStatusValue(successtext.progress_code) }}
        </div>
        <div v-if="checkPermissionsPage('admin') || checkPermissionsPage('mongolia_branch')">
          <div v-if="is_show" class="home-page__tags">
            <el-tag v-if="this.trackCodeMongoldIrsen" type="primary" class="cursor">
              <p @click="trackCodeDialogOpen(trackCodeMongoldIrsen)">Монголд ирсэн:
                {{ this.trackCodeMongoldIrsen.length }}
              </p>
            </el-tag>
            <el-tag v-if="this.trackCodeInChina" type="warning" class="cursor margin_left">
              <p @click="trackCodeDialogOpen(trackCodeInChina)">Эрээн салбараас гарсан: {{ this.trackCodeInChina.length }}
              </p>
            </el-tag>
          </div>
        </div>
        <el-row v-if="checkPermissionsPage('admin') || checkPermissionsPage('mongolia_branch')">
          <el-col :span="20" v-if="is_show">
            <el-form-item label="Утасны дугаар хайх" prop="phone_number">
              <el-col :span="22">
                <el-autocomplete
                  v-model="ruleForm.phone_number"
                  :fetch-suggestions="querySearch"
                  placeholder="Утасны эхний 4 орон"
                  @select="handleSelect"
                  @touchstart="handleSelectMobile"
                  :trigger-on-focus="false"
                  class="w-90 bg_style"
                  clearable>
                </el-autocomplete>

              </el-col>
              <el-col :span="2">
                <el-button @click="getTrackCodesBySamePhone('phone')" class="m-t-20">Хайх</el-button>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
        <div v-if="this.error && checkPermissionsPage('admin') || checkPermissionsPage('mongolia_branch')"
          style="color: red; padding: 20px;">
          {{ this.error }}
        </div>
        <el-row v-if="checkPermissionsPage('admin') || checkPermissionsPage('mongolia_branch')">
          <el-form-item label="Ачааны хэмжээ" prop="resource" v-if="is_show">
            <el-select v-model="ruleForm.config_type_id" placeholder="Ачааны төрөл сонгох" class="w-90">
              <el-option v-for="(item,index) in configData.ConfigType" :key="index" :label="item.name" :value="item.id" @click.native="giveValue(item.is_ezelhvvn)"></el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row v-if="this.ezelhuun === true && is_show">
          <el-form-item label="Урт /см/" prop="urt">
            <el-col :span="21">
              <el-input class="w-90" ref="urt" v-model="ruleForm.urt" placeholder="Урт"
                @input="(ruleForm.urt,'urgun','urt')" clearable
                type="tel"
                inputmode="decimal"></el-input>
            </el-col>
            <el-col :span="1">
              <el-button type="warning" icon="el-icon-camera-solid" circle></el-button>
            </el-col>
          </el-form-item>
        </el-row>
        <el-row v-if="this.ezelhuun === true && is_show">
          <el-form-item label="Өргөн /см/" prop="urgun">
            <el-col :span="21">
              <el-input class="w-90" ref="urgun" v-model="ruleForm.urgun" placeholder="Өргөн"
                @input="onBarcodeInput(ruleForm.urgun,'undur', 'urgun')" clearable
                type="tel"
                inputmode="decimal"></el-input>
            </el-col>
            <el-col :span="1">
              <el-button @click="startScan('urgun')" type="warning" icon="el-icon-camera-solid" circle></el-button>
            </el-col>
          </el-form-item>
        </el-row>
        <el-row v-if="this.ezelhuun === true && is_show">
          <el-form-item label="Өндөр /см/" prop="undur">
            <el-col :span="21">
              <el-input class="w-90" ref="undur" v-model="ruleForm.undur" placeholder="Өндөр"
                @input="onBarcodeInput(ruleForm.undur,'jin', 'undur')" clearable
                type="tel"
                inputmode="decimal"></el-input>
            </el-col>
            <el-col :span="1">
              <el-button @click="startScan('undur')" type="warning" icon="el-icon-camera-solid" circle></el-button>
            </el-col>
          </el-form-item>
        </el-row>
        <el-row v-if="checkPermissionsPage('admin') || checkPermissionsPage('mongolia_branch')">
          <el-form-item label="Жин /КГ/" prop="jin" v-if="this.ezelhuun === true">
            <el-input class="w-90" ref="jin" v-model="ruleForm.jin" placeholder="Жин"
              @input="onBarcodeInput(ruleForm.jin,'price', 'jin')" clearable
              type="tel"
              inputmode="decimal"></el-input>
          </el-form-item>
          <el-form-item label="Жин /ГР/" prop="jin" v-if="this.ezelhuun === false">
            <el-input class="w-90" ref="jin" v-model="ruleForm.jin" placeholder="Жин"
              @input="onBarcodeInput(ruleForm.jin,'price', 'jin')" clearable
              type="tel"
              inputmode="numeric"
              pattern="[0-9]*"></el-input>
          </el-form-item>
        </el-row>
        <div v-if="is_show">
          <el-button v-if="checkPermissionsPage('admin') || checkPermissionsPage('mongolia_branch')" @click="calculatePrice()">
              <span>Үнэ бодох</span>
            </el-button>
        </div>
        <div v-if="is_show">
          <el-form-item label="Үнэ /төг/" prop="price" v-if="checkPermissionsPage('admin') || checkPermissionsPage('mongolia_branch')">
            <el-input class="w-90" v-model="ruleForm.price" placeholder="Үнэ"
              type="tel"
              inputmode="decimal">
            </el-input>
          </el-form-item>
        </div>
        <el-row v-if="checkPermissionsPage('admin') || checkPermissionsPage('mongolia_branch')">
          <el-form-item label="Тавиурын код" prop="taviur_code" v-if="is_show">
            <el-col :span="21">
              <el-input class="w-90" ref="taviur_code" v-model="ruleForm.taviur_code" placeholder="Тавиурын дугаар"
                clearable></el-input>
            </el-col>
            <el-col :span="1">
              <el-button @click="startCameraTaviur('taviur_code')" type="warning" icon="el-icon-camera-solid" circle>
              </el-button>
            </el-col>
          </el-form-item>
        </el-row>
        <el-form-item>
          <div>
            <el-button class="w-90 home-page__primary-btn" ref="createButton" type="success" @click="submitForm('ruleForm')">Бүртгэх
            </el-button>
          </div>
          <div class="m-t-10">
            <el-button class="w-90 home-page__secondary-btn" @click="resetForm('ruleForm')">Цэвэрлэх</el-button>
          </div>
        </el-form-item>
      </div>
    </el-form>
    </div>
    <div>
      <el-dialog title="Трак кодын дэлгэрэнгүй" :visible.sync="this.$root.trackCodeDetailDialog" width="80%"
        :before-close="handleClose">
        <div v-for="item in trackCodeDetail" :key="item.id" class="track-item">
          <el-tag>{{ item.track_code }}</el-tag><br>
          <div class="item-details">
            <div v-if="item.phone_number"><b style="color: grey;">Утасны дугаар: &nbsp;</b>{{ item.phone_number }}</div>
          </div>
          <div class="item-details">
            <div v-if="item.description"><b style="color: grey;">Тайлбар: &nbsp;</b>{{ item.description }}</div>
          </div>
          <div class="item-details">
            <div v-if="item.product_size"><b style="color: grey;">Барааны хэмжээ: &nbsp;</b>{{ item.product_size }}
            </div>
          </div>
          <div class="item-details">
            <div v-if="item.product_type"><b style="color: grey;">Барааны төрөл: &nbsp;</b>{{ item.product_type }}</div>
          </div>
          <div class="item-details">
            <div v-if="item.jin"><b style="color: grey;">Жин: &nbsp;</b>{{ item.jin }}</div>
          </div>
          <div class="item-details">
            <div v-if="item.urt"><b style="color: grey;">Урт: &nbsp;</b>{{ item.urt }}</div>
          </div>
          <div class="item-details">
            <div v-if="item.undur"><b style="color: grey;">Өндөр: &nbsp;</b>{{ item.undur }}</div>
          </div>
          <div class="item-details">
            <div v-if="item.urgun"><b style="color: grey;">Өргөн: &nbsp;</b>{{ item.urgun }}</div>
          </div>
          <div class="item-details">
            <div v-if="item.is_paid"><b style="color: grey;">Төлбөр төлсөн эсэх: &nbsp;</b>
              <span v-if="(item.is_paid === true)" style="color: green;">Төлсөн</span>
              <span v-if="(item.is_paid === false)" style="color: red;">Төлөөгүй</span>
            </div>
          </div>
          <div class="item-details">
            <div v-if="item.price"><b style="color: grey;">Үнэ: &nbsp;</b>{{ item.price | formatCurrency}}</div>
          </div>
          <div class="item-details">
            <div v-if="item.createdAt"><b style="color: grey;">Үүсгэсэн огноо:
                &nbsp;</b>{{ item.createdAt.split('T')[0] }}</div>
          </div>
          <div class="item-details m-t-10">
            <el-tag v-if="item.progress_code" type="warning">{{ returnStatusValue(item.progress_code) }}</el-tag>
          </div><br>
          <div class="item-details">
            <el-tag v-if="item.track_code" type="info">Тавиур: &nbsp;{{ item.taviur_code }}</el-tag>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import services from '@/helpers/services'
// import axios from 'axios'
import { mapGetters } from 'vuex'
import { checkPermissions } from '@/helpers/custom'
import { BarcodeReader, BarcodeScanner } from 'dynamsoft-javascript-barcode'
import { debounce } from 'lodash'

// License key тохируулах
BarcodeReader.engineResourcePath = 'https://cdn.jsdelivr.net/npm/dynamsoft-javascript-barcode@latest/dist/'
BarcodeReader.productKeys =
    'DLS2eyJoYW5kc2hha2VDb2RlIjoiMTA2NDQwNjg5LU1UQTJORFF3TmpnNUxYZGxZaTFVY21saGJGQnliMm8iLCJtYWluU2VydmVyVVJMIjoiaHR0cHM6Ly9tZGxzLmR5bmFtc29mdG9ubGluZS5jb20vIiwib3JnYW5pemF0aW9uSUQiOiIxMDY0NDA2ODkiLCJzdGFuZGJ5U2VydmVyVVJMIjoiaHR0cHM6Ly9zZGxzLmR5bmFtc29mdG9ubGluZS5jb20vIiwiY2hlY2tDb2RlIjotMzgzOTE2MjU4fQ=='

// @ is an alias to /src
export default {
  name: 'HomeView',
  computed: {
    ...mapGetters([
      'user',
      'selectCompany'
    ])
  },
  data () {
    return {
      isShowCamera: false,
      companies: [{
        id: 1,
        company_name: 'Sky Cargo',
        nick_name: 'Анхаа'
      }, {
        id: 8,
        company_name: 'Мөөгий / 7588',
        nick_name: '7588'
      }],
      configData: {},
      showVideoTag: false,
      codeReader: null,
      barcodeData: null,
      showCamera: false,
      error: '',
      ruleForm: {
        config_type_id: null,
        company_id: null,
        track_code: '',
        phone_number: '',
        price: null,
        jin: null,
        urt: null,
        undur: null,
        urgun: null,
        ezelhuun: null,
        taviur_code: null,
        progress_code: null,
        code: null
      },
      rules: {
        track_code: [{
          required: true,
          message: 'Track Code хоосон байна',
          trigger: 'blur'
        }],
        une: [{
          required: true,
          message: 'Үнэ оруулна уу',
          trigger: 'change'
        }],
        urt: [{
          required: true,
          message: 'Урт оруулна уу',
          trigger: 'change'
        }],
        urgun: [{
          required: true,
          message: 'Өргөн оруулна уу',
          trigger: 'change'
        }],
        undur: [{
          required: true,
          message: 'Өндөр оруулна уу',
          trigger: 'change'
        }]
      },
      trackCodeMongoldIrsen: [],
      trackCodeInChina: [],
      trackCodeUserCreated: [],
      trackCodeUserReceived: [],
      trackCodeDetail: {},
      trackCode: null,
      ezelhuun: null,
      result: null,
      text: null,
      errortext: null,
      successtext: null,
      searchItem: null,
      clickedOnce: false,
      phones: [],
      checked: false,
      packageList: [],
      is_show: true
    }
  },
  created () {
    this.$nextTick(() => {
      if (this.$refs.track_code) {
        this.$refs.track_code.focus()
      } else {
        this.$notify({
          title: 'Алдаа',
          type: 'error',
          duration: 3000
        })
      }
    })
    this.getActiveConfigData('transportation')
  },
  methods: {
    handleSelectMobile (event) {
      if (this.isMobile()) {
        this.ruleForm.phone_number = event.target.innerText
      }
    },
    isMobile () {
      return /Mobi|Android/i.test(navigator.userAgent)
    },
    querySearch (queryString, cb) {
      if (!queryString || queryString.length < 3) return cb(new Error('Алдаа гарлаа')) // ✅ зөв

      services.getPhones({ phone_number: queryString })
        .then((response) => {
          if (response.type === 'success') {
            const suggestions = response.data.map(user => ({
              value: user.phone1
            }))
            cb(suggestions)
          } else {
            cb(new Error('Алдаа гарлаа')) // ✅ зөв
          }
        })
        .catch((err) => {
          this.$notify({
            title: 'Алдаа',
            type: 'error',
            message: err,
            duration: 3000
          })
          cb(new Error('Алдаа гарлаа')) // ✅ зөв
        })
    },
    handleSelect (item) {
      if (!this.isMobile()) {
        this.ruleForm.phone_number = item.value
      }
      this.onBarcodeInput(this.ruleForm.track_code, 'phone_number')
    },
    debouncedSearch: debounce(function () {
      this.getPhones()
    }, 500),
    getPhones () {
      const payload = { phone_number: this.ruleForm.phone_number }
      services.getPhones(payload)
        .then((response) => {
          if (response.type === 'success') {
            this.phones = response.data
          } else {
            this.error = response.message
          }
        })
        .catch((error) => {
          this.error = error
          this.$notify({
            title: 'Алдаа',
            type: 'error',
            message: error,
            duration: 3000
          })
        })
    },
    returnCompanyName (data) {
      const result = this.companies.find(({
        id
      }) => id === data)
      if (result) {
        return result.company_name
      } else {
        this.$router.push('/configPage')
      }
    },
    getActiveConfigData (data) {
      services.getActiveConfig(data)
        .then((response) => {
          if (response.type === 'success') {
            this.configData = response.data
          } else {
            this.error = response.message
          }
        })
        .catch((error) => {
          this.error = error
          this.$notify({
            title: 'Алдаа',
            type: 'error',
            message: error,
            duration: 3000
          })
        })
    },
    checkPermissionsPage (data) {
      return checkPermissions(data)
    },
    beforeDestroy () {
      if (this.codeReader) {
        this.codeReader.reset()
      }
    },
    async startCamera (column) {
      this.isShowCamera = true
      try {
        // Scanner үүсгэх
        this.scanner = await BarcodeScanner.createInstance()
        this.scanner.onFrameRead = (results) => {
          if (results.length > 0) {
            this.ruleForm[column] = results[0].barcodeText
            this.stopCamera()
          }
        }

        // dce-video-container класстай элемент зааж өгөх
        const videoContainer = document.querySelector('#barcode-scanner')
        await this.scanner.setUIElement(videoContainer)

        // Камер нээх
        await this.scanner.open()
        this.isCameraActive = true
      } catch (err) {
        alert(err)
        this.$notify({
          title: 'Алдаа',
          type: 'error',
          message: err,
          duration: 3000
        })
      }
    },
    async startCameraTaviur (column) {
      this.isShowCamera = true
      try {
        // Scanner үүсгэх
        this.scanner = await BarcodeScanner.createInstance()
        this.scanner.onFrameRead = (results) => {
          if (results.length > 0) {
            this.ruleForm[column] = results[0].barcodeText
            this.stopCameraTaviur()
          }
        }

        // dce-video-container класстай элемент зааж өгөх
        const videoContainer = document.querySelector('#barcode-scanner')
        await this.scanner.setUIElement(videoContainer)

        // Камер нээх
        await this.scanner.open()
        this.isCameraActive = true
      } catch (err) {
        this.$notify({
          title: 'Алдаа',
          type: 'error',
          message: err,
          duration: 3000
        })
      }
    },
    async stopCamera () {
      if (this.scanner) {
        await this.scanner.close()
        this.scanner.destroyContext()
        this.scanner = null
        this.isShowCamera = false
        this.getTrackCodesBySamePhone('track_code')
        this.getPhones()
      }
      this.isCameraActive = false
    },
    async stopCameraTaviur () {
      if (this.scanner) {
        await this.scanner.close()
        this.scanner.destroyContext()
        this.scanner = null
        this.isShowCamera = false
      }
      this.isCameraActive = false
    },
    onBarcodeInput (value, refName, column) {
      if (refName === 'createButton') {
        this.submitForm('ruleForm')
      } else {
        if (value.includes('@')) {
          const newValue = value.split('@')
          this.ruleForm[column] = newValue[0]
          this.$refs[refName].focus()
        }
      }
    },
    submitForm (formName) {
      try {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$root.fullscreenLoading = true
            this.ruleForm.company_id = this.selectCompany
            services.createTrackCode(this.ruleForm)
              .then((response) => {
                if (response.type === 'success' || response.message.type === 'success') {
                  this.$root.fullscreenLoading = false
                  this.ruleForm.track_code = null
                  this.ruleForm.phone_number = null
                  this.ruleForm.product_type_id = null
                  this.ruleForm.user_select_branch = null
                  this.ruleForm.price = null
                  this.ruleForm.track_code = null
                  this.ruleForm.product_size = null
                  this.ruleForm.product_type = null
                  this.ruleForm.jin = null
                  this.ruleForm.urt = null
                  this.ruleForm.undur = null
                  this.ruleForm.urgun = null
                  this.ruleForm.exchange = null
                  this.ruleForm.ezelhuun = null
                  this.ruleForm.teevriin_une = null
                  this.ruleForm.taviur_code = null
                  this.ruleForm.created_user_id = null
                  this.ruleForm.progress_code = null
                  this.ruleForm.config_type_id = null
                  this.playAudio()
                  // this.checked = true
                  this.$root.fullscreenLoading = false
                } else {
                  this.errortext = response.message
                  this.$root.fullscreenLoading = false
                }
              })
              .catch((error) => {
                this.$root.fullscreenLoading = false
                this.ruleForm.track_code = null
                this.playAudioError()
                this.$notify.error({
                  title: 'Error',
                  message: error
                })
              })
          } else {
            this.$root.fullscreenLoading = false
            this.ruleForm.track_code = null
            this.$notify({
              title: 'Алдаа',
              type: 'error',
              duration: 3000
            })
            return false
          }
        })
      } catch (error) {
        this.$root.fullscreenLoading = false
        this.ruleForm.track_code = null
        this.$notify({
          title: 'Амжилтгүй',
          message: 'Амжилтгүй',
          type: 'warning',
          duration: 3000
        })
      }
    },
    calculatePrice () {
      if (!this.ruleForm.config_type_id) {
        return this.$notify({
          title: 'Алдаа',
          message: 'Та ачааны хэмжээ сонгоно уу',
          type: 'error',
          position: 'top-left',
          timeout: 3000
        })
      } else if (!this.ruleForm.jin) {
        return this.$notify({
          title: 'Алдаа',
          message: 'Та ачааны жин оруулна уу',
          type: 'error',
          position: 'top-left',
          timeout: 3000
        })
      } else if (!this.ruleForm.urt && this.ezelhuun === true) {
        return this.$notify({
          title: 'Алдаа',
          message: 'Та ачааны урт оруулна уу',
          type: 'error',
          position: 'top-left',
          timeout: 3000
        })
      } else if (!this.ruleForm.urgun && this.ezelhuun === true) {
        return this.$notify({
          title: 'Алдаа',
          message: 'Та ачааны өргөн оруулна уу',
          type: 'error',
          position: 'top-left',
          timeout: 3000
        })
      } else if (!this.ruleForm.undur && this.ezelhuun === true) {
        return this.$notify({
          title: 'Алдаа',
          message: 'Та ачааны өндөр оруулна уу',
          type: 'error',
          position: 'top-left',
          timeout: 3000
        })
      }
      this.$root.fullscreenLoading = true
      services.calculatePrice(this.ruleForm.config_type_id, this.ruleForm.jin, this.ruleForm.urt, this.ruleForm.undur,
        this.ruleForm.urgun)
        .then((response) => {
          if (response) {
            this.ruleForm.price = response.finalPrice
            if (this.ezelhuun === true) {
              this.ruleForm.ezelhuun = response.ezelhuun
            }
            this.$root.fullscreenLoading = false
          }
        })
        .catch((error) => {
          this.$root.fullscreenLoading = false
          alert(error)
        })
    },
    playAudio () {
      const audio = new Audio(
        'https://daagiigaadskycargo.s3.ap-southeast-1.amazonaws.com/success.MP3')
      audio.play()
    },
    playAudioError () {
      const audio = new Audio(
        'https://daagiigaadskycargo.s3.ap-southeast-1.amazonaws.com/error.MP3')
      audio.play()
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    getTrackCodesBySamePhone (data) {
      // this.$root.fullscreenLoading = true
      this.trackCodeMongoldIrsen = []
      this.trackCodeInChina = []
      this.trackCodeUserCreated = []
      this.trackCodeUserReceived = []
      if (data === 'phone') {
        this.searchItem = this.ruleForm.phone_number
      } else {
        this.searchItem = this.ruleForm.track_code
      }
      services.getTrackCodesBySamePhone(this.searchItem, data)
        .then((response) => {
          if (response.type === 'success') {
            if (response.data.trackCode === null) {
              this.trackCodeMongoldIrsen = null
              this.trackCodeInChina = null
              this.ruleForm.product_size = null
              this.ruleForm.product_type = null
              this.ruleForm.jin = null
              this.ruleForm.urt = null
              this.ruleForm.undur = null
              this.ruleForm.urgun = null
              this.ruleForm.price = null
              this.ruleForm.taviur_code = null
              this.ruleForm.config_type_id = null
              this.ruleForm.phone_number = null
              this.errortext = null
            } else if (data === 'track_code') {
              this.ruleForm.phone_number = response.data.trackCode.phone_number
              this.ruleForm.product_size = response.data.trackCode.product_size
              this.ruleForm.product_type = response.data.trackCode.product_type
              this.ruleForm.jin = response.data.trackCode.jin
              this.ruleForm.urt = response.data.trackCode.urt
              this.ruleForm.undur = response.data.trackCode.undur
              this.ruleForm.urgun = response.data.trackCode.urgun
              this.ruleForm.price = response.data.trackCode.price
              this.ruleForm.price = response.data.trackCode.price
              this.ruleForm.config_type_id = response.data.trackCode.config_type_id
              this.successtext = response.data.trackCode
              this.errortext = null
            }
            this.trackCodeMongoldIrsen = response.data.trackCodeMongoldIrsen
            this.trackCodeInChina = response.data.trackCodeInChina
            this.ruleForm.taviur_code = response.data.trackCode.taviur_code
            this.errortext = null
            // this.$root.fullscreenLoading = false
          } else {
            this.errortext = response.data.message
            // this.$root.fullscreenLoading = false
          }
        })
        .catch((error) => {
          console.log(error)
          // this.$root.fullscreenLoading = false
        })
    },
    trackCodeDialogOpen (data) {
      this.trackCodeDetail = data
      this.$root.trackCodeDetailDialog = true
    },
    handleClose () {
      this.$root.trackCodeDetailDialog = false
    },
    returnStatusValue (data) {
      const result = this.$root.statusArray.find(element => element.value === data)
      if (result) {
        return result.label
      } else {
        return 'empty'
      }
    },
    giveValue (data) {
      this.ezelhuun = data
    },
    async getPackageList () {
      try {
        this.is_show = false
        this.$root.fullScreenLoading = true
        const payload = { progress_code: '210' }
        await services.getDeliveryList(payload)
          .then((response) => {
            if (response.type === 'success') {
              this.packageList = response.data
            }
          }).catch((error) => {
            this.error = error
            this.$notify({
              title: 'Алдаа',
              type: 'error',
              message: error,
              duration: 3000
            })
            this.$root.fullScreenLoading = false
          })
      } catch (error) {
        this.$notify({
          title: 'Алдаа',
          type: 'error',
          message: error,
          duration: 3000
        })
        this.$root.fullScreenLoading = false
      }
      this.$root.cargoDetailDialog = true
      this.$root.fullScreenLoading = false
    }
  }
}

</script>
<style>
  .home {
    text-align: center;
    padding-bottom: 100px;
  }

  .home-page {
    max-width: 640px;
    margin: 0 auto;
    padding: 16px 14px 28px;
    background: linear-gradient(180deg, #f1f5f9 0%, #f8fafc 40%, #fff 100%);
    min-height: 100%;
    text-align: left;
  }

  .home-page__hero {
    margin-bottom: 14px;
  }

  .home-page__title {
    margin: 0;
    font-size: 1.45rem;
    font-weight: 600;
    color: #0f172a;
    letter-spacing: -0.02em;
    text-align: left;
  }

  .home-page__subtitle {
    margin: 4px 0 0;
    font-size: 13px;
    color: #64748b;
  }

  .home-page__panel {
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    padding: 16px 14px 8px;
    box-shadow: 0 4px 14px rgba(15, 23, 42, 0.05);
  }

  .home-page__form .el-form-item__label {
    color: #475569 !important;
    font-weight: 500;
  }

  .home-page__form .el-input__inner,
  .home-page__form .el-textarea__inner {
    border-radius: 10px !important;
  }

  .home-page__status-banner {
    margin: 8px 0 12px;
    padding: 10px 12px;
    border-radius: 12px;
    background: #ecfdf5;
    border: 1px solid #a7f3d0;
    color: #065f46;
    font-size: 13px;
    line-height: 1.45;
  }

  .home-page__tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 10px;
  }

  .home-page__primary-btn,
  .home-page__secondary-btn {
    border-radius: 12px !important;
    font-weight: 600;
  }

  .el-form--label-top .el-form-item__label {
    padding: 0 !important;
  }

  .input-focused {
    border: 2px solid #409EFF;
    /* Focus үед цэнхэр хүрээ */
    outline: none;
    transition: border 0.2s;
  }

  .calculate_description {
    color: gray;
  }

  .calculate_layout {
    border-top: solid #007AFF;
  }

  svg {
    max-width: 100%;
  }

  .calculate_result {
    background-color: #D4E6FA;
    padding: 10%;
    text-align: center;
    line-height: 4;
  }

  .custom-radio {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #eeeeee;
    justify-content: center;
    padding: 16px;
    border: 2px solid transparent;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    line-height: 1.5;
    text-align: center;
    padding-right: 20px;
    width: 120px;
    text-align: -webkit-center;
  }

  .custom-radio:hover {
    border-color: #d3d3d3;
  }

  .el-radio__input {
    display: none;
  }

  .custom-radio.is-checked {
    border-color: #409eff;
    /* Element UI primary color */
    box-shadow: 0 0 5px rgba(64, 158, 255, 0.5);
  }

  .radio-image {
    width: 40px;
    height: 40px;
    object-fit: cover;
    border-radius: 8px;
  }

  .cursor {
    cursor: pointer;
  }

  .margin_left {
    margin-left: 10px !important;
  }

  .track-item {
    display: flex;
    flex-direction: column;
    background-color: #fff;
    padding: 10px;
    margin: 15px 0;
    border-radius: 8px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    transition: box-shadow 0.3s ease;
  }

  .track-item:hover {
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
  }

  .track-item el-tag {
    margin-bottom: 10px;
    padding: 5px 15px;
    font-size: 14px;
  }

  .item-details {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
  }

  .item-details span {
    font-size: 14px;
    color: #333;
  }

  .item-details span:nth-child(even) {
    color: #666;
  }

  .item-details span:hover {
    color: #ff6f61;
    cursor: pointer;
  }

  .dce-video-container {
    width: 300px !important;
    height: 200px !important;
    margin: 0 auto;
    z-index: 100000;
    border: 1px solid #ccc;
    border-radius: 8px;
  }
  .search_style {
    color: grey;
    font-size: 10px;
  }
  .search_style_error {
    color: red !important;
  }
  .search_style_success{
    color: greenyellow !important;
  }
  .el-autocomplete .el-input__inner {
    background-color: #f0f9eb; /* Хөнгөн ногоон өнгө */
  }

</style>
